import { log } from '../app/logger.js';
import { app } from '../app/app.js';
import { navigation } from '../app/navigation.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { window } from '../window.js';
import { AccountPanelBase } from './account_panel_base.js';

/**
 * Singup panel.
 */
class SignupPanel extends AccountPanelBase {
  static id = navigation.kSignupPanelId;

  initialize() {
    super.initialize();

    listenToEvent(this.formElement, 'submit', () => this.signup(), {
      blockUI: true,
      preventDefault: true,
    });

    listenToEvent(this.loginLink, 'click', () => navigation.toLogin(), {
      preventDefault: true,
    });
  }

  static markup = `
    <div class='spacer'></div>
    <div class='msg' hidden></div>
    <h1>Join <span class='designation'>CamperAid</span> today!</h1>
    <form class='default' autocomplete='never'>
      <input autocomplete='name'
             type='text'
             placeholder='Your name'
             required maxlength='254'><br>
      <input autocomplete='username'
             type='email'
             placeholder='Your email'
             required maxlength='254'><br>
      <input autocomplete='new-password'
             type='password'
             placeholder='New password'
             required>
      <button type='submit'>Sign up</button>
    </form>

    <span class='note'>
      By signing up, you agree to our <a href='/terms'>Terms &amp; Privacy Policy</a>
    </span>
    <span class='note'>
      Have an account? <a class='login-link' href='/login'>Log in</a>
    </span>
    <div class='spacer-3'></div>
  `;

  get historyState() {
    return [
      { page: this.page },
      `CamperAid - Join`,
      `${window.location.origin}/signup`,
    ];
  }

  switchOn() {
    document.body.setAttribute('signup-login-page', 'true');

    const { email } = navigation.params;
    if (email) {
      this.emailElement.value = email;
    }
    super.switchOn();
    this.nameElement.focus();
  }

  switchOff() {
    super.switchOff();
    document.body.removeAttribute('signup-login-page');
  }

  async signup() {
    const name = this.nameElement.value;
    const email = this.emailElement.value;
    const pwd = this.pwdElement.value;

    log(`[account] signup for '${name}'<${email}>`);
    this.msgBox.hide();

    let error = await app.signup({
      name,
      email,
      pwd,
    });
    if (error) {
      this.msgBox.error(
        `Failed to sign up. If you already have an account with us, then please
          <a href='/login' class='login-link'>log in</a>.
          If you believe you see this message by mistake, then please reach us at
          <a href='mailto:support@camperaid.com'>support@camperaid.com</a>`
      );
      listenToEvent(this.loginLink, 'click', () => navigation.toLogin(), {
        preventDefault: true,
      });
    }
  }

  static get selectors() {
    return Object.assign({}, super.selectors, {
      LoginLink: `.login-link`,
    });
  }

  static get elements() {
    return {
      loginLink: this.selectors.LoginLink,
    };
  }
}

navigation.registerPanel(SignupPanel);

export { SignupPanel };
